import styled, { keyframes } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.CONSTANTS.XH * 12}px;
  width: 100%;

  @media (min-width: 1025px) {
    height: ${({ theme }) => theme.CONSTANTS.XH * 14}px;
  }
`;

export const InnerWrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1025px) {
    transform: scale(0.88);
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(1.7); }
`;

export const Bars = styled.div`
  position: absolute;
  height: 60%;
  gap: 3px;
  z-index: 0;
  width: 125%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.85;
  margin-top: 1px;

  @media (min-width: 1025px) {
    height: 75%;
  }
`;

export const Bar = styled.div<{ delay: number; height: number }>`
  width: 4px;
  height: ${({ height }) => height}%;
  background: linear-gradient(to top, #00d9ff, #2a7e5e, #d41490);
  animation: ${pulse} 1.3s ease-in-out infinite;
  animation-delay: ${({ delay }) => delay}s;
  border-radius: 2px;
`;

export const TextOverlay = styled.div`
  z-index: 2;
  font-family: "Audiowide";
  font-weight: 500;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 38}px;
  color: ${({ theme }) => theme.THEME.white};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 14}px;
  }
`;

export const FoneImageLeft = styled.div`
  width: 100%;
  height: auto;
  filter: drop-shadow(0 0 8px #00d9ff);

  img {
    width: 48px;

    @media (min-width: 1025px) {
      width: 38px;
    }
  }
`;

export const FoneImageRight = styled.div`
  width: 100%;
  height: auto;
  filter: drop-shadow(0 0 8px #d41490);

  img {
    width: 48px;

    @media (min-width: 1025px) {
      width: 38px;
    }
  }
`;
